export const ResetPasswordFormInitialValues = {
  newPassword: '',
  confirmNewPassword: '',
};
